import {useSelector,useDispatch} from 'react-redux'
import {update} from './slice'
import Modal from 'react-bootstrap/Modal'

const VideoModal = ()=>{
	const dispatch = useDispatch()
	const show = useSelector(state=>state.videoModal.show)
	const heading = useSelector(state=>state.videoModal.heading) || 'Demo Video'
	const src = useSelector(state=>state.videoModal.src)
	const  handleClose = ()=>{
		dispatch(update({show:false}))
	}
	return (
		<Modal show={show} onHide={handleClose}>
			<Modal.Header closeButton>
				<Modal.Title>{heading}</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				{Boolean(src)&&
					<video style={{width:'100%'}} src={src} controls/>
				}
			</Modal.Body>
		</Modal>
	)
}

export default VideoModal